import React, { useReducer } from "react";

export enum DialogEnum {
  SIGN_IN = "Log In",
  FORGOT_PASSWORD = "Change Password",
  CONFIRM_REGISTRATION = "Verification code",
  CHANGE_PASSWORD = "Change password",
}

type State = { dialogs: DialogEnum[] };
type Action = { type: "PUSH"; payload: DialogEnum } | { type: "POP" };
type Reducer = (state: State, action: Action) => State;

type Actions = {
  push: (dialog: DialogEnum) => void;
  pop: () => void;
};

type Getters = {
  isOpened: (dialog: DialogEnum) => boolean;
};

const DialogContext = React.createContext<
  undefined | (State & Actions & Getters)
>(undefined);

const reducer: Reducer = (state, action) => {
  switch (action.type) {
    case "PUSH":
      return { ...state, dialogs: [...state.dialogs, action.payload] };
    case "POP":
      return { ...state, dialogs: state.dialogs.slice(0, -1) };
  }
};

const initialState: State = { dialogs: [] };

const DialogProvider = ({ children }: { children: React.ReactNode }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const actions: Actions = {
    push: (dialog) => dispatch({ type: "PUSH", payload: dialog }),
    pop: () => dispatch({ type: "POP" }),
  };

  const getters: Getters = {
    isOpened: (dialog) => state.dialogs[state.dialogs.length - 1] === dialog,
  };

  return (
    <DialogContext.Provider value={{ ...state, ...actions, ...getters }}>
      {children}
    </DialogContext.Provider>
  );
};

function useDialog() {
  const context = React.useContext(DialogContext);
  if (context === undefined)
    throw new Error("useDialog must be used within a DialogProvider");

  return context;
}

export { useDialog, DialogProvider };
